export default "__VITE_ASSET__a9af2160__"